import React from 'react';
import { Typography } from 'antd';
import { WeeklyStrategy, StrategyPhase } from '../../ProfitScenario/types';
import { calculatePhaseMetrics } from '../../ProfitScenario/calculations';

const { Text } = Typography;

interface MetricsColumnProps {
    week: WeeklyStrategy;
    phase: StrategyPhase;
    landedCost: number;
    fbaFee: number;
    referralRate: number;
    storageFee: number;
}

export const MetricsColumn: React.FC<MetricsColumnProps> = ({
    week,
    phase,
    landedCost,
    fbaFee,
    referralRate,
    storageFee
}) => {
    const metrics = calculatePhaseMetrics({ ...phase, weeks: [week] }, landedCost, fbaFee, referralRate, storageFee);
    const weekMetric = metrics.weeklyMetrics[0];
    const pricingMargin = weekMetric.sales > 0
        ? (((weekMetric.netProfit + weekMetric.adCost) / weekMetric.sales) * 100)
        : 0;

    return (
        <div style={{ fontSize: 14, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px 16px' }}>
            <div>销售额: <Text strong>${weekMetric.sales.toFixed(0)}</Text></div>
            <div>净毛利: <Text type={weekMetric.netProfit >= 0 ? 'success' : 'danger'} strong>${weekMetric.netProfit.toFixed(0)}</Text></div>
            <div>定价毛利: {pricingMargin.toFixed(1)}%</div>
            <div>净毛利率: {weekMetric.netMargin.toFixed(1)}%</div>
            {weekMetric.promotionNetMargin !== undefined && (
                <>
                    <div style={{ gridColumn: '1 / -1', borderTop: '1px dashed #e8e8e8', marginTop: 4, paddingTop: 6 }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>促销指标</Text>
                    </div>
                    <div>促销销售额: <Text strong>${weekMetric.promotionSales?.toFixed(0)}</Text></div>
                    <div>促销利润率: <Text type={weekMetric.promotionNetMargin >= 0 ? 'success' : 'danger'} strong>{weekMetric.promotionNetMargin.toFixed(1)}%</Text></div>
                </>
            )}
        </div>
    );
};
